/*********************************************************
 *                  Companies Ctrl
 *
 ********************************************************/


"use strict";

angular.module("exploitation")
	.controller("EitiCompaniesEditCtrl", ["$scope", "$location", "Utils", "company", "mode", "$uibModal", "EitiCompaniesService", "toastr", function ($scope, $location, Utils, company, mode, $uibModal, EitiCompaniesService, toastr) {

		/************************************************************************************************************
         *  SETUP
         *************************************************************************************************************/

		$scope.data = {
			company: company.data,
			mode: mode
		};

		var editCompanyModal;


		/************************************************************************************************************
         *  $scope functions
         *************************************************************************************************************/

		/**
         * Ouvrir la popup permettant de modifier le nombre de réseaux.
         * @param company
         */
		$scope.openEditCompanyModal = function () {
			editCompanyModal = Utils.openModal($uibModal, "edit.html", $scope);
		};


		$scope.post = function () {

			if ($scope.data.mode === "new") {

				EitiCompaniesService.addCompany($scope.data.company).then(() => {
					toastr.success("", "Compagnie créé");
					$location.path("/e-iti/companies");
				}).catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la création de la compagnie. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			} else if ($scope.data.mode === "edit") {
				EitiCompaniesService.edit($scope.data.company).then((response) => {
					toastr.success("", "Compagnie " + response.data.name + " mise à jour");
					$scope.data.company = response.data;
					$location.path("/e-iti/companies");
				}).catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la mise à jour de la compagnie. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			}
		};
	}]);